<template>
  <div>
    <ProductItem
      v-for="product in products"
      :key="product.handle"
      :product="product"
      :tracking-url="product.url"
      :recommendations="true"
    />
  </div>
</template>

<script>
import ProductItem from '../../components/product-item'

export default {
  components: {
    ProductItem
  },
  props: {
    limit: {
      type: Number,
      default: 4
    },
    intent: {
      type: String,
      default: 'related'
    },
    productId: {
      type: String,
      default: null
    },
    sectionId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      products: []
    }
  },
  computed: {
    safeLimit () {
      return this.limit + 7
    },
    recommendationsEndpoint () {
      return `/recommendations/products.json?product_id=${this.productId}&intent=${this.intent}&limit=${this.safeLimit}&section_id=${this.sectionId}`
    },
    backupRecommendationsEndpoint () {
      return `/recommendations/products.json?product_id=${this.productId}&intent=related&limit=${this.safeLimit - this.products.length}&section_id=${this.sectionId}`
    }
  },
  mounted () {
    this.getRecommendations()
  },
  methods: {
    async getRecommendations () {
      const recommendationsJSON = await this.axios.get(this.recommendationsEndpoint)
      const { data } = recommendationsJSON
      const { products } = data

      this.products = [...products.filter(product => !product.tags.includes('seo-hidden'))].slice(0, this.limit)

      /*
        If not enough complementary products are found
        pull in related products
      */
      if (this.products.length < this.limit && this.intent === 'complementary') {
        const backupRecommendationsJSON = await this.axios.get(this.backupRecommendationsEndpoint)
        const backupProducts = backupRecommendationsJSON.data.products.filter(product => !product.tags.includes('seo-hidden'))

        this.products = [...this.products, ...backupProducts].slice(0, this.limit)
      }
    },
  }
}
</script>
